import React from "react";
import type { Charge } from "../types";
import "./ChargeList.css";

type Props = {
  charges: Charge[];
  onDelete: (id: number) => Promise<void>;
};

export default function ChargeList({ charges, onDelete }: Props) {
  return (
    <div className="panel">
      <div className="panel-title">
        recent charges{" "}
        <span className="charge-count">{charges.length}</span>
      </div>
      {charges.length === 0 ? (
        <div className="charge-empty">no charges this period yet</div>
      ) : (
        <ul className="charge-list">
          {charges.slice(0, 12).map((c) => (
            <li className="charge-item" key={c.id}>
              <div className="charge-meta">
                <span className="charge-merchant">
                  {c.merchant || "manual"}
                </span>
                <span className="charge-time">{relTime(c.created_at)}</span>
              </div>
              <div className="charge-right">
                <span className="charge-amount">
                  -${(c.amount_cents / 100).toFixed(2)}
                </span>
                <button
                  className="charge-delete"
                  onClick={() => onDelete(c.id)}
                  title="remove charge"
                >
                  ×
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function relTime(iso: string): string {
  const t = new Date(iso).getTime();
  const diff = (Date.now() - t) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
